export const Hero = () => {
  return (
    <section id="intro" className="pt-10 pb-16 sm:pt-16 sm:pb-20">
      <div className="space-y-6">
        <h1 className="font-serif font-bold text-3xl sm:text-4xl leading-tight text-ink-800">
          <span className="block font-mono text-xs font-normal tracking-wider text-ink-600 mb-3">
            西野 颯真 — ソフトウェアエンジニア
          </span>
          0から1を、
          <br className="hidden sm:block" />
          プロダクトにする。
        </h1>
        <p className="text-base leading-[1.95] text-ink-600">
          福岡を拠点に、WebアプリやAIを活用した業務システムをつくっています。
          アイデアの段階から、設計・実装・公開・運用まで一貫して形にします。
          生成AIの活用やインフラ構築も手がけています。
        </p>
        <p className="font-mono text-xs tracking-wider text-ink-600">
          プロダクト 0→1 / AI活用 / フルスタック＋インフラ
        </p>
      </div>
    </section>
  )
}
